function ForgotPasswordController($scope, dataService) {
    $scope.model = {
        username: null
    };
    $scope.loading = false;

    var resetVal = function() {
        $scope.val = {};
    }
    resetVal();

    $scope.handleUsernameChange = function() {
        delete $scope.val.username;
        delete $scope.val.status;
    };

    $scope.submit = function(e) {
        e.preventDefault();
        resetVal();

        if (!$scope.model.username) {
            $scope.val.username = 'Email address is required.';
        }

        // Any errors?
        if (!_.isEmpty($scope.val)) return;
        // Login
        $scope.loading = true;
        dataService.forgotPassword($scope.model.username)
            .then(function() {
                location.href = '/login/?forgot=complete'
                $scope.loading = false;
            })
            .catch(function(err) {
                console.error(err);
                if (err.status === 404) $scope.val.status = 'Invalid email address.';
                else $scope.val.status = 'Unable to submit request at this time.';
                $scope.loading = false;
            });
    };
}

angular.module('app')
    .component('forgotPassword', {
        transclude: true,
        controller: ['$scope', 'dataService', ForgotPasswordController],
        templateUrl: '/assets/built/app/components/forgotPassword/forgotPassword.html'
    });
